webpackJsonp([132483249527680],{

/***/ 1205:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0040_void_star.jpg","type":"Unit","subtype":"Mech Airship","cost":5,"ATK":5,"HP":4,"rules_text_1":"Flying, overpower","rules_text_2":"④ → Gets +4 ATK until your next upkeep. Once-per-turn.","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Void Star","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Purple","spec":"Future","bottom":"Tech II","rulings":[],"keywords":["Flying","Overpower"],"slug":"void_star"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"void_star","keywords":["Flying","Overpower"],"imageRegex":"/void_star.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-void-star-d426800ed02c694bd517.js